module.exports = __webpack_public_path__ + "static/media/share.65337b03.svg";